import { useMemo, useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import GameCatalog from "../../components/GameCatalog";
import { RiArrowDropRightFill } from "react-icons/ri";
import SupplierList from "../../components/GameSelect/SupplierList";
import TopTab from "../Home/components/topTab";
import MobileSearch from "../Search/mobile-search";
import InfiniteScroll from "react-infinite-scroller";
import useWindowWidth from "../../hook/useWindowWidth";
import useDeviceType from "../../hook/useDeviceType";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import NotFound from "../../components/ProgressBlock/NotFound";
import { languageTransfer } from "../../utils/languageTransfer";
import i18next from "i18next";
import GAMEITEM from "../../components/GAMEITEM/GAMEITEM";
import { filterType } from "../../hook/useGameListFilter";
import useCasinoType from "../../hook/useCasinoType";

const GamePlatformPage = () => {
  const { gamePlatform } = useParams();

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);

  const windowWidth = useWindowWidth();
  const isMobile = useDeviceType() === "Mobile";

  const casinoType = useCasinoType();

  const { platform, sortedByPlatformGames } = isHandleAllGame;

  const [displayedItems, setDisplayedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const resultGameList = useMemo(() => {
    if (gamePlatform) {
      return filterType({
        gameList: sortedByPlatformGames?.[gamePlatform],
        casinoType: casinoType,
      });
    }
  }, [sortedByPlatformGames, gamePlatform]);

  useEffect(() => {
    setCurrentPage(1);
    setIsLoading(true);
  }, [gamePlatform]);

  const ITEMS_PER_PAGE = useMemo(() => {
    if (windowWidth >= 1280) {
      return 32;
    } else if (windowWidth >= 1024) {
      return 35;
    } else if (windowWidth >= 768) {
      return 25;
    } else {
      return 12;
    }
  }, [windowWidth]);

  useEffect(() => {
    setDisplayedItems(resultGameList?.slice(0, ITEMS_PER_PAGE));
  }, [resultGameList, ITEMS_PER_PAGE]);

  const loadMore = useCallback(() => {
    setTimeout(() => {
      const moreItems = resultGameList?.slice(
        0,
        (currentPage + 1) * ITEMS_PER_PAGE
      );
      if (moreItems?.length >= displayedItems?.length) {
        setDisplayedItems(moreItems);
        setIsLoading(false);
        setCurrentPage((prevPage) => prevPage + 1);
      }
    }, 300);
  }, [currentPage, displayedItems?.length]);

  const hasMoreItems = useMemo(() => {
    return displayedItems?.length < resultGameList?.length;
  }, [displayedItems?.length]);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  }, [isLoading]);

  return (
    <>
      <section className="md:hidden flex flex-col gap-[10px]">
        <TopTab />
        <MobileSearch />
      </section>
      <div className="mb-[8px] h-[30px] md:h-[56px] flex items-center">
        <div className="mx-[16px] text-base-light-dark dark:text-base-light-white font-semibold text-xl">
          {gamePlatform}
        </div>
      </div>

      <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={hasMoreItems}
        useWindow={isMobile}
        loader={<LoadingBlock commonLoading={true} />}
      >
        <LoadingBlock commonLoading={isLoading}>
          {displayedItems?.length === 0 && <NotFound />}
          <section className="grid lg:grid-cols-7 md:grid-cols-5 grid-cols-3 xl:grid-cols-8 md:gap-x-[16px] gap-[10px] px-common-padding-x gap-y-[24px]">
            {displayedItems?.map((item, index) => {
              const gameName =
                item?.[
                  `gameName${languageTransfer({
                    lang: i18next.language,
                  })}`
                ];
              const gameNameEn = item?.gameNameEn;
              const platform = item?.game_platform;
              const gameSubType = item?.game_subtype;

              const gameCode = item?.gameCode;
              const gameType = item?.gameType;
              return (
                <GAMEITEM
                  gameProps={{
                    gameName,
                    platform,
                    gameCode,
                    gameType,
                    gameNameEn,
                    gameSubType,
                  }}
                  originProps={item}
                  itemClass={`!h-[155px]`}
                  index={index}
                />
              );
            })}
          </section>
        </LoadingBlock>
      </InfiniteScroll>

      <section className="px-common-padding-x mb-[20px]">
        <SupplierList LIST={platform} customNavigate="/casino/category/" />
      </section>
    </>
  );
};

export default GamePlatformPage;
